import React, { FC } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { AbbTheme } from 'theme/createAbbTheme';

export type Props = {};

export const DesktopSection: FC<Props> = ({ children }) => {
  const matches = useMediaQuery<AbbTheme>((theme) =>
    theme.breakpoints.up('lg')
  );

  if (matches) {
    return <>{children}</>;
  }

  return null;
};
